import Modal from "common/components/Modal/Modal"
import {
  GET_AVAILABLE_DOCUMENTOS_TO_GENERATE,
  TIPO_DOCUMENTO,
} from "common/utils/documentos"
import { COLOR_PRIMARY } from "common/utils/theme"
import { nanoid } from "nanoid"
import { useMemo } from "react"
import { Clipboard, File, FilePlus, Package } from "react-feather"
import DocumentoActionItem from "../../DocumentoActionItem"

const TEMPORAL_DESCRIPTION =
  "No his munere interesset. At soluta accusam gloriatur eos"

const DOCUMENTOS = [
  {
    Icon: () => <File style={{ color: COLOR_PRIMARY }} />,
    title: "presupuesto",
    description: TEMPORAL_DESCRIPTION,
    documento: TIPO_DOCUMENTO.PRESUPUESTO,
    key: nanoid(),
  },
  {
    Icon: () => <Package style={{ color: COLOR_PRIMARY }} />,
    title: "pedido",
    description: TEMPORAL_DESCRIPTION,
    documento: TIPO_DOCUMENTO.PEDIDO,
    key: nanoid(),
  },
  {
    Icon: () => <Clipboard style={{ color: COLOR_PRIMARY }} />,
    title: "albarán",
    description: TEMPORAL_DESCRIPTION,
    documento: TIPO_DOCUMENTO.ALBARAN,
    key: nanoid(),
  },
  {
    Icon: () => <FilePlus style={{ color: COLOR_PRIMARY }} />,
    title: "factura",
    description: TEMPORAL_DESCRIPTION,
    documento: TIPO_DOCUMENTO.FACTURA,
    key: nanoid(),
  },
]

const GenerateDocumentoModal = ({
  onHide,
  visible,
  tipoDocumento,
}: $TSMigrationFixMe) => {
  const documentos = useMemo(() => {
    const availableDocumentosToGenerate =
      GET_AVAILABLE_DOCUMENTOS_TO_GENERATE[tipoDocumento]
    return DOCUMENTOS.filter((DOCUMENTO) =>
      availableDocumentosToGenerate?.includes(DOCUMENTO.documento)
    )
  }, [tipoDocumento])

  return (
    <Modal
      onHide={onHide}
      visible={visible}
      header='Generar documento'
    >
      <div className='row d-flex justify-content-center m-0'>
        {documentos.map(({ key, Icon, title, description, documento }) =>
          documento !== tipoDocumento ? (
            <div
              key={key}
              className='col-md-4 col-sm-12 p-0'
            >
              <DocumentoActionItem
                Icon={Icon}
                title={title}
                description={description}
              />
            </div>
          ) : null
        )}
      </div>
    </Modal>
  )
}

export default GenerateDocumentoModal
